var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsDashboardTopbarEnIconWhite = function SvgNewcsDashboardTopbarEnIconWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "newcs_dashboard_topbar_en_icon_white_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#707070",
    d: "M187 342h22v22h-22z",
    "data-name": "\\u77E9\\u5F62 325"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#newcs_dashboard_topbar_en_icon_white_svg__a)",
    transform: "translate(-187 -342)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 20,
    fill: "#fff",
    "data-name": "\\u77E9\\u5F62 231",
    rx: 4,
    transform: "translate(187 343)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#393157",
    d: "M192.835 350.27v2.2h3.93v.86h-3.93v2.4h4.33v.86h-5.3v-7.18h5.23v.86Zm10.36 4.94v-5.8h.94v7.18h-1.09l-3.65-5.8h-.02v5.8h-.94v-7.18h1.15l3.59 5.8Z",
    "data-name": "\\u8DEF\\u5F84 422"
  }))));
};
export default SvgNewcsDashboardTopbarEnIconWhite;